import React from 'react'
import { NavbarTwo } from '../components/Layout/Navbar'
import Footer from '../components/Layout/Footer'
import './ProductDetail.css'

const SealProductPage = ({ title, description, images, imageAlt }) => (
  <div className="product-detail-page product-detail-page--seal">
    <NavbarTwo />
    <main className='2xl:pt-[120px] pt-[80px] xl:pt-[110px] lg:pt-[100px]'>
      <section className='bg-white lg:pt-24 lg:pb-12 pt-12 pb-8 px-4 lg:px-12'>
        <div className='flex items-center justify-center flex-col'>
          <h1 className='lg:text-[2.2rem] text-[1.6rem] text-center bg-gradient-to-r from-[#99821d] via-[#ccc595] to-[#9d8944] inline-block text-transparent bg-clip-text uppercase lg:leading-[2.5rem] font-[GilroyBold]'>
            {title}
          </h1>
        </div>
        <div className={`grid grid-cols-1 ${images.length > 2 ? 'lg:grid-cols-5' : 'lg:grid-cols-2'} items-start justify-center my-8 xl:gap-8 gap-4`}>
          {images.map((image, index) => (
            <img className='rounded-lg w-full' src={image} alt={`${imageAlt} ${index + 1}`} key={image} />
          ))}
        </div>
        <p className='max-w-6xl mx-auto text-gray-600 text-[.85rem] xl:text-[1rem] leading-7 text-center'>
          {description}
        </p>
      </section>
    </main>
    <Footer />
  </div>
)

export default SealProductPage
